import api from '../../services/api';

// Mock detailed proposal data (fallback)
const sampleDetails = {};

function makeDetail(idNum) {
  const id = `ORC-00${idNum}`;
  return {
    id,
    title: 'Residência Alto Padrão',
    client: 'Mateus da Silva',
    createdAt: '08/05/2024 às 10:30',
    status: 'Em elaboração',
    responsible: { name: 'Mateus Teixeira', avatar: null },
    subtotal: 16200,
    discount: 0,
    taxes: 810,
    total: 18500,
    marginPct: 35,
    estimatedProfit: 6475,
    products: [
      { id: 1, title: 'Desenvolvimento de fachada', desc: 'Modelagem e texturização externa', qty: 1, unit: 7500, total: 7500 },
      { id: 2, title: '10 imagens internas/externas 3D', desc: 'Imagens realistas em FULL HD', qty: 10, unit: 450, total: 4500 },
      { id: 3, title: 'Planta baixa com medidas básicas', desc: 'Layout técnico com medidas', qty: 1, unit: 1200, total: 1200 },
      { id: 4, title: '1 Vídeo interno/externo 60seg', desc: 'Vídeo 3D realista em FULL HD', qty: 1, unit: 3000, total: 3000 }
    ],
    activities: [
      { id: 1, title: 'Orçamento criado', by: 'Mateus Teixeira', at: '08/05/2024 às 10:30' },
      { id: 2, title: 'Informações do projeto editadas', by: 'Maria Oliveira', at: '08/05/2024 às 11:20' },
      { id: 3, title: 'Orçamento enviado ao cliente', by: 'Mateus Teixeira', at: '08/05/2024 às 12:00' }
    ],
    files: [
      { id: 'f1', name: 'Briefing_Residencia_Alto_Padrao.pdf', size: '1.2 MB', type: 'pdf', uploadedAt: '08/05/2024' },
      { id: 'f2', name: 'Planta_Baixa.pdf', size: '950 KB', type: 'pdf', uploadedAt: '08/05/2024' },
      { id: 'f3', name: 'Imagens_Referencia.zip', size: '24.5 MB', type: 'zip', uploadedAt: '08/05/2024' }
    ]
  };
}

// prefill one detail
sampleDetails['ORC-00238'] = makeDetail(238);

export async function getProposalDetail(id) {
  // Try backend first; fallback to mock detail on error
  try {
    const res = await api.get(`/proposals/${id}`);
    const data = res.data;
    if (data && typeof data === 'object') {
      try { console.log('getProposalDetail: API returned', data); } catch (e) {}
      return data;
    }
  } catch (err) {
    // console.warn('getProposalDetail API failed, using mock detail', err);
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(sampleDetails[id] || makeDetail(238));
    }, 200);
  });
}
